import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface IProps {
	subroute: {
		name: string;
		path: string;
	};
}

let SectionpageCard: React.FC<IProps> = ({ subroute }) => {
	let { t: routesTranslation } = useTranslation('routes');

	return (
		<Link to={subroute.path}>
			<div className="h-100 d-flex justify-content-center align-items-center rounded primary_4-bg primary_5-bg-hover display-2 gray_1 primary_1-hover">
				{routesTranslation(subroute.name)}
			</div>
		</Link>
	);
};

export default SectionpageCard;
